// Choosing a language from what a browser or a request says.
//
// Promise: both functions are pure. `resolveLocale` compares primary subtags
// (`ja` of `ja-JP`) in the order given and falls back when none is supported;
// `parseAcceptLanguage` orders tags by q (highest first, ties keep their order)
// and drops `*` and malformed q values.
import { type Locale, locales } from "./paraglide/runtime.js";

export function resolveLocale(
  tags: readonly string[],
  fallback: Locale,
): Locale {
  for (const tag of tags) {
    const primary = tag.trim().toLowerCase().split("-")[0];
    const hit = locales.find((l) => l === primary);
    if (hit) return hit;
  }
  return fallback;
}

export function parseAcceptLanguage(
  header: string | null | undefined,
): string[] {
  if (!header) return [];
  return header
    .split(",")
    .map((part, index) => {
      const [tag, ...params] = part.trim().split(";");
      const q = params.map((p) => p.trim()).find((p) => p.startsWith("q="));
      return { tag: tag.trim(), q: q ? Number(q.slice(2)) : 1, index };
    })
    .filter((x) => x.tag !== "" && x.tag !== "*" && !Number.isNaN(x.q))
    .sort((a, b) => b.q - a.q || a.index - b.index)
    .map((x) => x.tag);
}
